import { addDays, format, parse } from 'date-fns';

export interface Epic {
  key: string;
  summary: string;
  requirements: FunctionalRequirement[];
}

export interface FunctionalRequirement {
  key: string;
  summary: string;
  startDate: string;
  endDate: string;
  color: string;
}

const epics: Epic[] = [];

const startDate = addDays(new Date(), -90);
const formatDate = (date: Date) => format(date, 'yyyy-MM-dd');
const addEpic = (summary: string) => {
  epics.push({ key: summary, summary, requirements: [] });
};

const addRequirement = (
  summary: string,
  startFromLast: number,
  duration: number,
  color: string
) => {
  const epic = epics[epics.length - 1];
  // const previousEpic = epics[epics.length - 2];
  // const lastRequirement =
  //   epic.requirements.length === 0
  //     ? previousEpic?.requirements[previousEpic.requirements.length - 1]
  //     : epic.requirements[epic.requirements.length - 1];
  const lastRequirement =
    epic.requirements.length === 0
      ? null
      : epic.requirements[epic.requirements.length - 1];
  const lastRequirementEndDate = lastRequirement
    ? lastRequirement.endDate
      ? parse(lastRequirement.endDate, 'yyyy-MM-dd', new Date())
      : new Date()
    : new Date();
  const startDate = addDays(lastRequirementEndDate, startFromLast);
  const endDate = addDays(startDate, duration);
  epic.requirements.push({
    key: summary,
    summary,
    startDate: format(startDate, 'yyyy-MM-dd'),
    endDate: format(endDate, 'yyyy-MM-dd'),
    color
  });
};

addEpic('Preparation');
addRequirement('Policies and Procedures ', -30, 10, '#567a08');
addRequirement('Organizational charts ', -10, 10, '#2b66d6');
addRequirement('ePHI data flow diagrams ', 1, 11, '#e02e2a');
addRequirement('ePHI asset inventory (applications, databases, servers, end-user devices, etc.) ', -11, 11, '#2b66d6'); // prettier-ignore
addRequirement('Network diagrams ', 1, 5, '#b141cc');
addRequirement('Prior assessments (ISO, internal assessments, 3rd party audits, etc.)', -5, 10, '#6a6c6b'); // prettier-ignore

addEpic('Gap Assessment');
addRequirement('Extract current control definitions ', -30, 10, '#897d1f');
addRequirement('Formalize and document alignment of these controls with myCSF ', -10, 10, '#897d1f'); // prettier-ignore
addRequirement('Gap Assessment of ePHI environment against HITRUST requirements (interviews, observation, and technical reviews) ', 1, 15, '#567a08'); // prettier-ignore
addRequirement('Assess risk and control gaps advise how to close said gaps ', 1, 11, '#e02e2a'); // prettier-ignore
addRequirement('Determine Maturity Score (1-5) ', -11, 11, '#e02e2a');
addRequirement('Design remediation roadmap ', 1, 5, '#b141cc');

addEpic('Generating Evidence and Internal Audit');
addRequirement('Execute remediation roadmap ', 15, 15, '#b141cc');
addRequirement('Generate new or revised documentation ', -15, 15, '#b141cc');
addRequirement('Training ', -15, 15, '#b141cc');
addRequirement('Complete Internal Audit Review ', 1, 10, '#6a6c6b');
addRequirement('Verify the scope of ePHI application and identify key system owners and IT support.', 1, 10, '#2b66d6'); // prettier-ignore
addRequirement('Obtain the InfoSys Scoping worksheet and schedule a business walk-through. ', -10, 10, '#2b66d6'); // prettier-ignore
addRequirement('Confirm that the regulatory requirements are tested for myCSF Controls Conduct interviews with key system owners and IT support Review CSF Baseline Assessments and test CSF organizational and system controls.', 1, 15, '#b141cc'); // prettier-ignore
addRequirement('Evaluate remediation efforts and document new controls, processes, and procedures into myCSF. ', -15, 15, '#e02e2a'); // prettier-ignore
addRequirement('Conduct CSF Test Plans for ePHI application in scope and document test sample requirements ', -15, 15, '#e02e2a'); // prettier-ignore
addRequirement('Perform interviews and validation testing', -5, 10, '#567a08');
addRequirement('Evaluate test results and assess information security risks by HITRUST specifications ', -10, 10, '#567a08'); // prettier-ignore
addRequirement('Documentation of results and discuss remediation plans.', -10, 10, '#2b66d6'); // prettier-ignore
addRequirement('Re-validation testing (verify controls are functioning and documents have been updated) ', -10, 10, '#2b66d6'); // prettier-ignore
addRequirement('Assess any failed controls and determine the course of action to correct these failures. ', -10, 10, '#6a6c6b'); // prettier-ignore

addEpic('HITRUST Certification Assessment');
addRequirement('HITRUST certification', 75, 10, '#567a08'); // prettier-ignore
addRequirement('Resolve observations and retest.', 1, 15, '');
addRequirement('Resubmit for evaluation', -5, 5, '');
addRequirement('Certification', 1, 15, '');

export function useGetQualityRoadmap() {
  return epics;
}
